// React
import { useDocumentTitle } from '@refinedev/react-router-v6';

// Refine
import { useTranslation } from '@refinedev/core';

// Mantine
import {
  Paper,
  Title,
  useComputedColorScheme,
  useMantineTheme,
  Stack,
  Text,
} from '@mantine/core';

//Auth
import { useCurrentUserStore } from 'store/UserStore';

// Custom Components
import { DashboardMetrics } from './DashboardMetrics';
import { DashboardBanner } from 'components/common/DashboardBanner';

// Hooks
import { useCurrentTimeOfDay } from 'hooks';
import { toTitleCase } from 'utils/stringUtils';
import { useCurrentSiteStore } from 'store';

export const Dashboard = () => {
  const { firstName, lastName } = useCurrentUserStore();
  const { timezone } = useCurrentSiteStore();
  const timeOfDay = useCurrentTimeOfDay(timezone);
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme('dark');
  const { translate } = useTranslation();
  const greeting = translate(`greetings.${timeOfDay}`);
  const name = `${toTitleCase(firstName, lastName)}`;
  useDocumentTitle('Home | QBilling');

  return (
    <Paper
      withBorder
      p="md"
      radius={'md'}
      bg="transparent"
      data-testid="dashboard-page"
    >
      <DashboardBanner configKey="dashboard_banner" />
      <Stack gap={4} mb="md" px={8} align="flex-start">
        <Title order={1} fw={700} data-testid="provider-dashboard-title">
          {greeting}
        </Title>
        <Text
          size={'md'}
          fw={600}
          c={theme.colors[`primary-${computedColorScheme}`][0]}
        >
          {name}
        </Text>
      </Stack>
      <DashboardMetrics />
    </Paper>
  );
};
